export const bookedBBBSlots = (bbbLicense: string | null | undefined) => {
  return bbbLicense ? parseInt(bbbLicense, 10) : 0;
};
